import { ButtonProps } from "../../../../types"
import Button from "../button"

const DefaultBtn = ({ children, className = "", ...rest }: ButtonProps) => (
  <Button
    {...rest}
    className={`${className} border-gray-300 shadow-sm bg-white text-gray-500 hover:bg-gray-50`}
  >
    {children}
  </Button>
)

export default DefaultBtn
